export default "__VITE_ASSET__CcoIG2C5__"